/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BundleItemPickerService {
  selectedBundleLineItem = new BehaviorSubject([]);
  onAddBundleItemClicked = new Subject();

  constructor() {}
}
